import { render, staticRenderFns } from "./MemberLink.vue?vue&type=template&id=4dbd7cbb&lang=pug"
import script from "./MemberLink.vue?vue&type=script&lang=ts"
export * from "./MemberLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports